import Hot from './Hot';
export default Hot;
